module.exports = __webpack_public_path__ + "static/media/untitled.8ab0c249.svg";